import React, { useEffect } from 'react';
import { useOvermind } from 'src/overmind';

const Dashboard = () => {
    const { state, actions } = useOvermind()

    useEffect(() => {
        actions.vsoDashboard.setCurrentPage('dash');
    }, []);

    return (
        <div>Dashboard</div>
    )
}

export default Dashboard;